"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _moment = _interopRequireDefault(require("moment"));

var _reactDatetime = _interopRequireDefault(require("react-datetime"));

require("react-datetime/css/react-datetime.css");

var _component = _interopRequireDefault(require("../component.js"));

var _ = require("../");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/*---------------------------------------------*/
var Datepicker = /*#__PURE__*/function (_Component) {
  _inherits(Datepicker, _Component);

  var _super = _createSuper(Datepicker);

  function Datepicker() {
    var _this;

    _classCallCheck(this, Datepicker);

    _this = _super.call(this);
    _this.state = {
      value: 1 * new Date()
    };
    _this.onClick = _this.onClick.bind(_assertThisInitialized(_this));
    _this.onInputChange = _this.onInputChange.bind(_assertThisInitialized(_this));
    _this.onPickerChange = _this.onPickerChange.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(Datepicker, [{
    key: "onClick",
    value: function onClick(e) {}
  }, {
    key: "onPickerChange",
    value: function onPickerChange(valueMoment) {
      var value = {
        year: valueMoment.year(),
        month: valueMoment.month(),
        day: valueMoment.date()
      };
      this.setState({
        value: value,
        inputValue: undefined
      });
      this.props.onChange && this.props.onChange(value);
    }
  }, {
    key: "onInputChange",
    value: function onInputChange(value) {
      this.setState({
        inputValue: value
      });
      var dateFormat = this.props.dateFormat || this.constructor.DEFAULT_DATE_FORMAT;
      var valueMoment = (0, _moment.default)(value, dateFormat);

      if (valueMoment.isValid()) {
        this.setState({
          value: 1 * valueMoment
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      this.resetClassNames();
      this.addClass(this.constructor.BASE_CLASS);
      var value = this.props.value || this.state.value;
      var valueMoment = (0, _moment.default)(value);
      var dateFormat = this.props.dateFormat || this.constructor.DEFAULT_DATE_FORMAT;
      var valueStr = valueMoment.isValid() ? valueMoment.format(dateFormat) : "";

      var inputProps = _objectSpread(_objectSpread({}, this.props), {}, {
        value: this.state.inputValue || valueStr,
        label: null,
        onChange: this.onInputChange,
        iconRight: "calendar",
        iconRightColor: "var(--datepicker-icon-color)"
      });

      var timeSlots = Array(24 * 4).fill(null).map(function (value, index) {
        var hours = String(Math.floor(index / 4)).padStart(2, "0");
        var minutes = String(15 * Math.floor(index % 4)).padStart(2, "0");
        return "".concat(hours, ":").concat(minutes);
      });
      var timeOptions = timeSlots.map(function (value, index) {
        return {
          value: index,
          label: value
        };
      });

      var label = this.props.label && /*#__PURE__*/_react.default.createElement(_.Label, null, this.props.label);

      return /*#__PURE__*/_react.default.createElement("div", {
        style: this.getStyle(),
        className: this.getClassNames()
      }, label, /*#__PURE__*/_react.default.createElement("div", {
        className: this.constructor.BASE_CLASS + "__container"
      }, /*#__PURE__*/_react.default.createElement("label", {
        className: this.constructor.BASE_CLASS + "__sublabel"
      }, this.props.dateLabel), /*#__PURE__*/_react.default.createElement(_reactDatetime.default, {
        className: this.constructor.BASE_CLASS + "__date",
        value: valueMoment,
        timeFormat: false,
        closeOnSelect: true,
        isValidDate: function isValidDate(currentDate, selectedDate) {
          return _this2.props.minDate ? currentDate.isAfter((0, _moment.default)(_this2.props.minDate)) : true;
        } // /* attempt to display currently selected range. kind of works. note - value overrides initialViewDate */
        // initialViewDate={this.state.hoverDate}
        // renderDay={(props, currentDate, selectedDate) => {
        // 	let dateInsideRange = (this.props.minDate && this.state.hoverDate && currentDate.isAfter(this.props.minDate) && currentDate.isBefore(this.state.hoverDate));
        // 	props.style = {
        // 		background: dateInsideRange ? 'blue' : ''
        // 	}
        // 	return <td {...props} onMouseOver={() => {
        // 		this.setState({hoverDate: currentDate})
        // 	}}>{currentDate.date()}</td>;
        // }}
        ,
        onChange: this.onPickerChange,
        renderInput: function renderInput(props, openPicker, closePicker) {
          return /*#__PURE__*/_react.default.createElement(_.Input, _extends({}, inputProps, {
            onClick: openPicker
          }));
        }
      }), /*#__PURE__*/_react.default.createElement("label", {
        className: this.constructor.BASE_CLASS + "__sublabel"
      }, this.props.timeLabel), /*#__PURE__*/_react.default.createElement(_.Select, {
        className: this.constructor.BASE_CLASS + "__time",
        options: timeOptions,
        placeholder: "Choose time"
      })));
    }
  }]);

  return Datepicker;
}(_component.default);
/*---------------------------------------------*/


exports.default = Datepicker;

_defineProperty(Datepicker, "BASE_CLASS", "lth-c-datepicker");

_defineProperty(Datepicker, "DEFAULT_DATE_FORMAT", "DD-MM-YYYY");

_component.default.METADATA = {
  name: "Datepicker",
  props: [{
    name: "label",
    type: "string",
    default: "Enter your input"
  }, {
    name: "value",
    type: "string",
    default: ""
  }, {
    name: "placeholder",
    type: "string",
    default: "Enter your input"
  }, {
    name: "dateLabel",
    type: "string",
    category: "view"
  }, {
    name: "timeLabel",
    type: "string",
    category: "view"
  }, {
    name: "disabled",
    type: "boolean",
    default: false
  }, {
    name: "error",
    type: "boolean",
    default: false
  }, {
    name: "forcehover",
    type: "boolean",
    default: false
  }, {
    name: "forcefocus",
    type: "boolean",
    default: false
  }, {
    name: "message",
    type: "string"
  }, {
    name: "onChange",
    type: "function"
  }]
};